import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Locale } from 'antd/es/locale';
import de_DE from 'antd/locale/de_DE';
import en_US from 'antd/locale/en_US';
import hr_HR from 'antd/locale/hr_HR';
import uk_UA from 'antd/locale/uk_UA';
import dayjs from 'dayjs';

import 'dayjs/locale/de';
import 'dayjs/locale/hr';
import 'dayjs/locale/uk';

const localeMap: Record<string, Locale> = {
  en: en_US,
  hr: hr_HR,
  uk: uk_UA,
  de: de_DE,
};

// dayjs.locale() є глобальним синглтоном для всього застосунку, тож цей
// side-effect свідомо не ізольований — останній змонтований інстанс хука
// "виграє", але оскільки мова одна на весь застосунок, це завжди коректно.
export const useAntdDatePickerLocale = (): Locale => {
  const { i18n } = useTranslation();

  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  return useMemo(
    () => localeMap[i18n.language] ?? en_US,
    [i18n.language]
  );
};
